import { render, staticRenderFns } from "./EquivalentItem.vue?vue&type=template&id=a11696e2&scoped=true"
import script from "./EquivalentItem.vue?vue&type=script&lang=js"
export * from "./EquivalentItem.vue?vue&type=script&lang=js"
import style0 from "./EquivalentItem.vue?vue&type=style&index=0&id=a11696e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a11696e2",
  null
  
)

export default component.exports